import {
  FormControl,
  FormLabel,
  Button,
  Input,
  Text
} from '@chakra-ui/react';
import { useState } from 'react';

interface ImageFileInputProps {
  inputRef: React.RefObject<HTMLInputElement>;
  label: string;
  accept?: string;
}

const ImageFileInput = ({
  inputRef,
  label,
  accept = 'image/*'
}: ImageFileInputProps) => {
  const [fileName, setFileName] = useState<string>("");

  const handleFileChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    if (event.target.files && event.target.files[0]) {
      setFileName(event.target.files[0].name);
    }
  };

  const handleClick = () => {
    inputRef.current?.click();
  };

  return (
    <FormControl>
      <FormLabel>{label}</FormLabel>

      <Input
        type="file"
        ref={inputRef}
        onChange={handleFileChange}
        accept={accept}
        display="none"
      />

      <Button onClick={handleClick} colorScheme="blue">
        {fileName ? "Cambiar archivo" : "Seleccionar archivo"}
      </Button>

      {fileName && <Text mt={2}>{fileName}</Text>}
    </FormControl>
  );
};

export default ImageFileInput;
